exports = module.exports = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/** 常用色值 **/\n/** 常用字体大小 **/\n.footer {\n  text-align: center;\n  color: #999;\n  padding: 10px 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader?{"importLoaders":1}!./node_modules/.pnpm/registry.npmmirror.com+postcss-loader@2.0.8/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/.pnpm/registry.npmmirror.com+less-loader@4.1.0_less@2.7.3+webpack@3.8.1/node_modules/less-loader/dist/cjs.js!./src/components/Footer/index.less
// module id = 394
// module chunks = 20